import React from 'react';
import { Container, Grid, Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import image1 from '../../images/service1.webp';
import image2 from '../../images/service2.webp';
import image3 from '../../images/service3.webp';
import image4 from '../../images/service4.webp';
import image5 from '../../images/service5.webp';
import image6 from '../../images/service6.webp';

const services = [
  {
    title: 'UI/UX Design',
    description: 'CGS specializes in visually appealing UI/UX design, creating user-friendly interfaces for enhanced satisfaction and engagement.',
    image: image1,
  },
  {
    title: 'Back-end Development',
    description: 'Crafting smooth data processing with Python, Java, or PHP. We design website functionality, server-side logic, and APIs for peak performance.',
    image: image2, 
  },
  {
    title: 'E-commerce Solutions',
    description: 'Design intuitive e-commerce platforms for secure payments, catalog browsing, and inventory management to boost sales success.',
    image: image3, 
  },
  {
    title: 'Cloud Solutions',
    description: 'Provide robust cloud infrastructure with scalable cloud hosting, ensuring reliability and performance.',
    image: image4,
  },
  {
    title: 'SEO Optimization',
    description: 'Our SEO services boost your website’s ranking, visibility, and organic traffic for long-term success.',
    image: image5, 
  },
  {
    title: 'Mobile App Development',
    description: 'We create responsive and feature-rich mobile applications for seamless user experiences on both iOS and Android.',
    image: image6, 
  },
];

const GradientText = styled(Typography)({
  background: 'linear-gradient(90deg, rgba(255,0,150,1) 0%, rgba(0,204,255,1) 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
});

const Services = () => {
  return (
    <Box sx={{ backgroundColor: '#e9f3ff', padding: '60px 0' }}>
      <Container>
        <Box sx={{ textAlign: 'center', marginBottom: '40px' }}>
          <GradientText variant="overline" sx={{ color: 'magenta', fontWeight: 'bold', mb: 2 ,fontSize:'16px', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
            Services
          </GradientText>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0a003d', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }} gutterBottom>
            Our Services
          </Typography>
          <Typography variant="subtitle1" sx={{ fontSize: '16px', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
            We think big and have hands in all leading technology platforms to provide you a wide array of services.
          </Typography>
        </Box>
        
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card 
                sx={{ 
                  maxWidth: 345, 
                  margin: 'auto', 
                  textAlign: 'center', 
                  padding: '20px', 
                  height: 'auto',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 8px 20px rgba(35, 48, 152, 0.5)',
                  }
                }}
              >
                <CardMedia
                  sx={{ height: 120, margin: '20px auto', objectFit: 'contain' }}
                  image={service.image}
                  title={service.title}
                />
                <CardContent>
                  <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ fontWeight: 'bold', color: '#0d47a1', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {service.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ color: '#757575', marginTop: '10px', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
